module.exports = __webpack_public_path__ + "static/media/handMixer.7dc5eddc.png";